import { useState, useEffect } from "react";
import { Quote } from "lucide-react";
import { testimonials } from "../mock";
import { useLang } from "../i18n";

export default function Testimonials() {
  const { lang, t } = useLang();
  const [active, setActive] = useState(0);

  useEffect(() => {
    const iv = setInterval(() => setActive((a) => (a + 1) % testimonials.length), 6000);
    return () => clearInterval(iv);
  }, []);

  return (
    <section className="py-24 lg:py-32 bg-[#9C3B2E] text-[#FAF4EA] relative overflow-hidden">
      <div className="absolute -left-32 -top-32 w-96 h-96 rounded-full bg-[#F0D9A7]/5 blur-3xl" />
      <div className="max-w-4xl mx-auto px-6 text-center relative">
        <Quote className="w-14 h-14 mx-auto text-[#F0D9A7]/50" strokeWidth={1.2} />
        <div className="mt-8 grid">
          {testimonials.map((tm, i) => (
            <blockquote
              key={tm.id}
              className={`col-start-1 row-start-1 transition-all duration-700 ${
                i === active ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
              }`}
            >
              <p className="font-display italic text-2xl sm:text-3xl leading-relaxed font-500">
                „{tm.text[lang] || tm.text.de}“
              </p>
              <footer className="mt-8">
                <span className="font-600 text-[#F0D9A7] text-lg">{tm.author}</span>
                <span className="block text-white/60 text-sm mt-1">{t("testimonials.source")}</span>
              </footer>
            </blockquote>
          ))}
        </div>
        <div className="mt-14 flex items-center justify-center gap-3">
          {testimonials.map((tm, i) => (
            <button
              key={tm.id}
              onClick={() => setActive(i)}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === active ? "w-8 bg-[#F0D9A7]" : "w-2 bg-white/30 hover:bg-white/50"
              }`}
              aria-label={`Stimme ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
